<template>
  <div class="w-9/12">
    <div class="bg-white flex items-center rounded-full shadow-xl">
      <input 
        id="search" 
        v-model="searchValue"
        type="text"
        class="rounded-l-full w-full  px-6 text-gray-700 leading-tight focus:outline-none lg:text-lg" 
        placeholder="Search"
        autocomplete="off" />
      <div class="p-2">
        <button @click="searchBy" class="bg-green-400 text-white rounded-full p-2 hover:bg-green-600 focus:outline-none w-10 h-10 flex items-center justify-center">
          <font-awesome-icon :icon="['fas','search']" size="1x"/>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Search',
  data: function () {
    return {
      searchValue: ""
    }
  },
  methods: {
    searchBy: function () {
      alert('SEARCH METHODS CALL. Value = ' + this.searchValue);
    }
  }
}
</script>